export type CollagePhoto = {
  id: string
  file: File
  url: string
  naturalWidth: number
  naturalHeight: number
}

export type GridSettings = {
  gapPx: number
  backgroundColor: string
}

export const MIN_GAP_PX = 0
export const MAX_GAP_PX = 40

export const DEFAULT_GRID_SETTINGS: GridSettings = {
  gapPx: 8,
  backgroundColor: '#ffffff',
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value))
}
